<template>
  <div class="flex flex-col gap-4">
    <!-- Chart panel -->
    <MessageComponent v-if="hideMeasurements" color="info">
      {{
        $p("no-measurements-available", {
          type: typeLabel,
        })
      }}
    </MessageComponent>
    <AssetChartPanel
      v-else
      :metering-point="filterStore.currentMeteringPoint"
      :date-range="filterStore.dateRange"
      show-stats
      show-annotations
    />
  </div>
</template>

<script setup>
import { computed } from "vue"
import $p from "@/services/phraseService.js"
import {
  ASSET_TYPE_HIDDEN_MEASUREMENTS,
  ASSET_TYPE_LABELS,
} from "@/stores/repower/meteringPointStoreFactories.js"
import useFilterStore from "@/stores/filterStore.js"
import AssetChartPanel from "@/components/panels/AssetChartPanel.vue"
import MessageComponent from "@/components/information/MessageComponent.vue"

const filterStore = useFilterStore()

const hideMeasurements = computed(() =>
  ASSET_TYPE_HIDDEN_MEASUREMENTS.includes(
    filterStore.currentMeteringPoint?.type,
  ),
)

const typeLabel = computed(
  () => ASSET_TYPE_LABELS[filterStore.currentMeteringPoint?.type],
)
</script>
